import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";
import { LinkExternalIcon } from "@twilio/flex-ui/node_modules/@twilio-paste/icons/esm/LinkExternalIcon";


function isValidHttpUrl(input) {
    try {
        const url = new URL(input);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
        return false;
    }
}

const InfoField = ({ label, value, isLink = false, hrefPrefix = ""}) => {
    const trimmed = (value || "").trim();
    if (!trimmed) return null;

    const linkUrl = isLink ? `${hrefPrefix}${trimmed}` : "";
    const isValidUrl = isValidHttpUrl(linkUrl);
    return (
        <div>
        <h2 className="bold">{label}</h2>
        <p>
            {isValidUrl ? (
            <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                {trimmed}
            </a>
            ) : trimmed}
            <br />
        </p>
        </div>
    );
};

export class TaskInfoSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { serviceBaseUrl: uhaulStore.getState().UhaulReducer.currentUser.serviceBaseUrl };
    }

    render() {
        if (this.props != null && this.props.task != null && this.props.task.attributes != null) {

            var propAttrs = this.props.task.attributes;
            var parsedPickUpDateTime = propAttrs.pickupDateTime != null ? propAttrs.pickupDateTime.split(" ") : [];
            var parsedReturnDateTime = propAttrs.returnDateTime != null ? propAttrs.returnDateTime.split(" ") : [];

            var currentUser = uhaulStore.getState().UhaulReducer.currentUser;
            var sessionGuid = (currentUser && currentUser.sessionGuid) ? currentUser.sessionGuid : "";
            var isMobileAdvantage = propAttrs.mobileAdvantage ?? false;
            var isWPS = propAttrs.type && propAttrs.type.includes("workplace-solutions");

            if (isWPS) {
                return (<div>
                    <InfoField label="Employee's Name" value={propAttrs.friendlyName} isLink={true} hrefPrefix="https://uhaul.net/tools/customermanagement/Search?SearchTerm=" />
                    <InfoField label="Employee's Smid" value={propAttrs.smid} />
                    <InfoField label="Employee's Entity" value={propAttrs.entity} />
                    <InfoField label="Employee's Job Code" value={propAttrs.jobcode} />
                </div>)
            }
            else {
                return (<div>
                    <div>
                        <h2 className="bold">Customer's Name</h2>
                        {!isMobileAdvantage && propAttrs.friendlyName && propAttrs.friendlyName !== "" ?
                            <p><a href={"https://uhaul.net/tools/customermanagement/Search?SearchTerm=" + propAttrs.friendlyName} target="_blank" rel="noopener noreferrer">{propAttrs.friendlyName}</a><br /></p>
                            : null}
                        {propAttrs.callerName && propAttrs.callerName !== "" ?
                            <p>{propAttrs.callerName}<br /></p>
                            : null}
                    </div>

                    {isMobileAdvantage ?
                        <div>
                            <h2 className="bold">Call Type</h2>
                            <p>{propAttrs.callType}<br /></p>
                            <h2 className="bold">Call Id</h2>
                            <p>
                                <a href={propAttrs.openUrl && propAttrs.openUrl.trim() !== '' 
                                ? decodeURIComponent(propAttrs.openUrl) 
                                : uhaulStore.getState().UhaulReducer.config.roadsideUrl + "callSummary/Index/" + propAttrs.callId} target="_blank" rel="noopener noreferrer">{propAttrs.callId}</a><br />
                                </p>
                        </div> : null}

                    <InfoField label="Entity" value={propAttrs.entity} isLink={true} hrefPrefix="https://uhaul.net/contact/crosscontact/Entity/Index/" />
                    <InfoField label="Customer Link" value={propAttrs.customerlink} isLink={true} />
                    <InfoField label="Contract Type" value={propAttrs.contractType} />
                    <InfoField label="Job Number" value={propAttrs.jobNumber} />
                    {propAttrs.contractID != null && propAttrs.contractID !== "" ?
                        <div>
                            <h2 className="bold">Contract # {propAttrs.documentNumber}</h2>
                            <p>{propAttrs.status !== null && (propAttrs.status.toLowerCase() === "reservation" || propAttrs.status.toLowerCase() === "dispatched" || propAttrs.status.toLowerCase() === "cancelled") ?
                                <div>
                                    <a href={"https://poslogin.uhaul.net/secure/launchtosite/Launch.aspx?app=POS&ConsoleApp=RTA&contractId=" + propAttrs.contractID + "&logInEntity=" + propAttrs.entity + "&entity=" + propAttrs.entity + "&toLocation=Summary&fromTraffic=true&guid=" + sessionGuid} target="_blank" rel="noopener noreferrer">View Contract in POS</a><br />
                                </div> : null}
                                <a href={"https://uhaul.net/equipment/contractlookup/Contract/" + propAttrs.contractID} target="_blank" rel="noopener noreferrer">View Contract in Uhaul.net</a><br />
                            </p></div> : null}

                    {propAttrs.phoneNumber !== null && propAttrs.phoneNumber !== "" ?
                        <div>
                            <h2>Phone Number</h2>
                            <p><a href={"tel:" + propAttrs.phoneNumber} target="_blank" rel="noopener noreferrer">{propAttrs.phoneNumber}</a>&nbsp;&nbsp;<a href={"https://uhaul.net/tools/customermanagement/Search?SearchTerm=" + propAttrs.phoneNumber} target="_blank" rel="noopener noreferrer">&nbsp;<LinkExternalIcon display={"inline-block"} title="Search for phone number in CMT" /></a><br /></p>
                        </div> : null}

                    {propAttrs.email !== null && propAttrs.email !== "" ?
                        <div>
                            <h2 className="bold">Email</h2>
                            <p><a href={"mailto:" + propAttrs.email} target="_blank" rel="noopener noreferrer">{propAttrs.email}</a>&nbsp;&nbsp;<a href={"https://uhaul.net/tools/customermanagement/Search?SearchTerm=" + propAttrs.email} target="_blank" rel="noopener noreferrer">&nbsp;<LinkExternalIcon display={"inline-block"} title="Search for email address in CMT" /></a><br /></p>
                        </div> : null}


                    <InfoField label="Reference URL" value={propAttrs["uhaulcom-url"]} isLink={true} />
                    <InfoField label="Customer's Browser/Device" value={propAttrs.initiatingDevice} />
                    {propAttrs.status || propAttrs.equipment ?
                        <div>
                            <h2 className="bold">Rental/Reservation Information</h2>
                            <p><b>Status:</b> {propAttrs.status} <br />
                                <b>Equipment:</b> {propAttrs.equipment}<br />
                                <b>Pick Up Date:</b> {parsedPickUpDateTime !== null && parsedPickUpDateTime.length > 0 ? parsedPickUpDateTime[0] : ""}<br />
                                <b>Pick Up Time:</b> {parsedPickUpDateTime !== null && parsedPickUpDateTime.length > 1 ? parsedPickUpDateTime[1] + (parsedPickUpDateTime[2] != null ? parsedPickUpDateTime[2] : "") : ""}<br />
                                <b>Return Date:</b> {parsedReturnDateTime !== null && parsedReturnDateTime.length > 0 ? parsedReturnDateTime[0] : ""}<br />
                                <b>Return Time:</b> {parsedReturnDateTime !== null && parsedReturnDateTime.length > 1 ? parsedReturnDateTime[1] + (parsedReturnDateTime[2] != null ? parsedReturnDateTime[2] : "") : ""}</p>
                        </div> : null}
                    
                    <InfoField label="SMID" value={propAttrs.smid} />
                    <InfoField label="Agent Name" value={propAttrs.agentName} />
                    <InfoField label="Browser Type" value={propAttrs.browserType} />
                    <InfoField label="Browser Version" value={propAttrs.browserVersion} />
                    <InfoField label="Operating System" value={propAttrs.operatingSystem} />
                    <InfoField label="IP Address" value={propAttrs.ipAddress} />
                    <InfoField label="Location" value={propAttrs.location} />
                    <InfoField label="Summary" value={propAttrs.summary} />
                </div>)
            }
        }
        else {
            return null;
        }
    }
}
